import { getShopInfo } from 'api/shop';
import { ShopInfo } from 'comps/ShopInfoHead';
import { allSettled } from 'libs/utils';
import ShopCategory from 'views/ShopCategory';

export type CategoryPageData = {
  shopInfo: ShopInfo;
};
/**
 * 店铺分类
 */
export default function PageCategory(props: CategoryPageData) {
  return <ShopCategory {...props} />;
}

export async function getServerSideProps(ctx) {
  const props: CategoryPageData = {
    shopInfo: {
      sysNo: '',
      supplierSysNo: '',
      name: '',
      mainBusiness: '',
      serviceHotline: '',
      serviceHours: '',
      mallCategoryTreeDTO: {
        categories: [],
      },
      score: '',
    },
  };

  const serverHeaders = ctx.req.headers;
  const shopSysNo = ctx.query.id;
  const [shopInfoRes] = await allSettled([
    getShopInfo(shopSysNo, {
      serverSide: true,
      headers: serverHeaders,
    }),
  ]);
  props.shopInfo = buildShopData(shopInfoRes.data?.data ?? props.shopInfo);
  return { props };
}

function buildShopData(data: ShopInfo): ShopInfo {
  let categories = [];
  data?.mallCategoryTreeDTO?.categories?.forEach((item) => {
    const childCategory = item?.children || [];
    if (childCategory?.length) {
      const subList = childCategory.map((childItem) => ({
        ...childItem,
        showMore: false,
        children:
          childItem?.children?.map((subChildItem) => ({
            ...subChildItem,
            children: null,
          })) || null,
      }));
      categories = [...categories, ...subList];
    }
  });
  return {
    sysNo: data.sysNo,
    supplierSysNo: data.supplierSysNo,
    name: data.name,
    mainBusiness: data.mainBusiness,
    serviceHotline: data.serviceHotline,
    serviceHours: data.serviceHours,
    mallCategoryTreeDTO: {
      categories,
    },
    score: data.score,
  };
}
